// import React, { useEffect } from 'react'
// import Layout from '../../Layout'
// import { useLead } from '../../../hooks/Features/useLeads'
// import { formatDate, formatNumber } from '../../../shared/constants'

// export default function LeadDumpReportForPivot() {
//   const { loading, getLeadDumpReport, lead } = useLead()
//   const startDate = new Date()
//   startDate.setDate(1)
//   startDate.setHours(0, 0, 0)
//   const [from, setFrom] = React.useState(startDate)
//   const [to, setTo] = React.useState(new Date())

//   useEffect(() => {
//     getLeadDumpReport({ from: from, to: to })
//   }, [from, to])

//   const heading = [
//     { label: 'Lead Status', key: 'ls' },
//     { label: 'Promoter Name', key: 'pn' },
//     { label: 'Outlet', key: 'ol' },
//     { label: 'Region', key: 'region' },
//     { label: 'Zone', key: 'zone' },
//     { label: 'State', key: 'state' },
//     { label: 'District', key: 'district' },
//     { label: 'city', key: 'city' },
//     { label: 'TSM', key: 'tsm' },
//     { label: 'Lead Date', key: 'ld' },
//     { label: 'WishList', key: 'wl' },
//     { label: 'Likely Closure Date', key: 'lcd' },
//     { label: 'Expected Order Value', key: 'eov' },
//     { label: 'Quote Number', key: 'quote' },
//     { label: 'Customer Name', key: 'cn' },
//     { label: 'Customer Phone No.', key: 'cp' },
//     { label: 'Customer E-Mail', key: 'cm' },
//     { label: 'Customer Address', key: 'ca' },
//   ]

//   let tempLead = []
//   lead &&
//     lead.forEach((item) =>
//       tempLead.push({
//         ls: item.status,
//         pn: item.rank6Name,
//         ol: item.outlet,
//         region: item.region && item.region.name,
//         zone: item.zone && item.zone.name,
//         state: item.state && item.state.name,
//         district: item.district && item.district.name,
//         city: item.city && item.city.name,
//         tsm: item.rank5Name,
//         ld: formatDate(item.leadDate),
//         wl: item.wishList.join(', '),
//         lcd: formatDate(item.closureDate),
//         eov: formatNumber(item.orderValue),
//         quote: item.quoteNumber,
//         cn: item.customer.name,
//         cp: item.customer.mobile,
//         cm: item.customer.email,
//         ca: item.customer.address,
//       })
//     )
//   return (
//     <Layout
//       heading="Lead Dump Report"
//       none
//       selectedFrom={from}
//       setSelectedFrom={setFrom}
//       selectedTo={to}
//       setSelectedTo={setTo}
//       headers={heading}
//       data={tempLead ? tempLead : []}
//       tempHeaderData={[]}
//       filename='lead_dump_report'
//     >
//       <div style={{ fontSize: '20px', textAlign: 'center', marginTop: '10px', opacity: '0.8' }}>
//         Click On Download Button to Download
//       </div>
//     </Layout>
//   )
// }

import moment from 'moment'
import React, { useEffect, useState } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { useLead } from '../../../hooks/Features/useLeads'
import { formatDate, getAllData } from '../../../shared/constants'

export default function AuditReport() {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })
  console.log({ STATE_DATA: state })

  const filterData = state.data
  const [page, setPage] = React.useState(1)
  const [from, setFrom] = React.useState(moment().startOf('month').toISOString())
  const [to, setTo] = React.useState(new Date().toISOString())
  useEffect(() => {
    getAllData(
      'GET_LEAD_DUMP_REPORT',
      {
        page: page,
        limit: 10,
        from: from,
        to: to,
      },
      state,
      setState
    )
  }, [page, from, to])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item) => {
      return [
        { value: item.rank6Name },
        { value: item?.store?.name ?? '--' },
        { value: item?.area?.name ?? '--' },
        { value: item?.city?.name ?? '--' },
        { value: item?.district?.name ?? '--' },
        { value: item?.state?.name ?? '--' },
        { value: item?.zone?.name ?? '--' },
        { value: item?.region?.name ?? '--' },
        { value: item.customerName },
        { value: item.leadType },
        // { value: item.productArray },
        { value: formatDate(item.createdDate) },
        { value: formatDate(item.followUp) },
        { value: formatDate(item.closureDate) },
        { status: item.leadStatus, type: 'STATUS_ENUM' },

        // { value: item.otherDetails && formatDate(item.otherDetails[0].auditDate) },
        // { value: item.otherDetails && item.otherDetails[0].totalAuditScore },
        // { value: item.otherDetails && item.otherDetails[0].modifiedAuditScore },
        // { value: item.status.OPEN },
        // { value: item.status.SUBMIT },
        // { value: item.status.COMPLETE },
        // { value: item.status.REOPEN },
        // { value: item.totalTasks },
      ]
    })
  }

  const layoutProps = {
    heading: 'Lead Dump Report',
    filename: 'lead_dump_reports',
    selectedFrom: from,
    setSelectedFrom: setFrom,
    selectedTo: to,
    setSelectedTo: setTo,
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    // <>asas</>
    <CustomTableLayout
      tableHeadings={[
        'Employee NAme',
        'store',
        'area',
        'city',
        'district',
        'state',
        'zone',
        'region',
        'lead name',
        'lead type',
        // 'wishlist',
        'created date',
        'follow up',
        'closure date',
        'leadStatus',
        // 'total audit score',
        // 'audit score',
        // 'Open',
        // 'Submit',
        // 'Completed',
        // 'Reopen',
        // 'total tasks',
      ]}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}
